<template>
	<div>
		<Header />

		<div>
			<Carousel loop :height="350" arrow="never" dots="none">
				<CarouselItem>
					<div class="banner">
						<div>
							<p class="pageType">数据类服务</p>
						</div>
					</div>
				</CarouselItem>
			</Carousel>
			<div>
				<div class="serviceIntroduction">
					<ul class="serviceTypeList">
						<p>数据类服务</p>
						<li v-for="(item,i) in data" :class="{'active':i+1==type}" @click="skipService(i)">
							{{item.title}}
						</li>
					</ul>
					<div class="introductionInfo">
						<p>{{data[type-1].title}}</p>
						<div class="serviceContent">
							<component :is="data[type-1].component"></component>
						</div>
					</div>
					
					 <div style="clear: both;"></div>
				</div>

			</div>

		</div>

		<ContactUs />
		<Footer />
	</div>
</template>

<script>
	import Header from '@/common/header'
	import Footer from '@/common/footer.vue'
	import ContactUs from '@/common/contactUs.vue'
	import DataAssetDealmaking from '@/views/services/data/components/dataAssetDealmaking.vue'
	import DataAssetExchangeListing from '@/views/services/data/components/dataAssetExchangeListing.vue'
	import DataProductQualityAssessment from '@/views/services/data/components/dataProductQualityAssessment.vue'
	import DataResourcesEntry from '@/views/services/data/components/dataResourcesEntry.vue'
	
	import {
		merge
	} from 'lodash'

	export default {
		components: {
			Header,
			Footer,
			ContactUs,
			DataAssetDealmaking,
			DataAssetExchangeListing,
			DataProductQualityAssessment,
			DataResourcesEntry
		

		},
		data() {
			return {
				type: this.$route.query.type,
				data: [{
					title: '数据资产交易撮合',
					component: 'DataAssetDealmaking'
				}, {
					title: '数据资产交易所挂牌',
					component: 'DataAssetExchangeListing'
				}, {
					title: '数据产品质量评估',
					component: 'DataProductQualityAssessment'
				}, {
					title: '数据资源入表',
					component: 'DataResourcesEntry'
				}]

			}
		},
		mounted() {
			window.addEventListener('scroll', this.handleScroll);

		},
		beforeDestroy() {
			window.removeEventListener('scroll', this.handleScroll);
		},
		methods: {
			handleScroll() {
				if (window.pageYOffset >= 410) {
					$('.serviceTypeList').addClass('service-fixed')

				} else {
					$('.serviceTypeList').removeClass('service-fixed')
				}

			},
			skipService(i){
				this.type=i+1
				
				this.$router.push({
					query: merge({}, {
						'type': i+1
					})
				})
			}


		}


	}
</script>

<style scoped lang="less">
	.banner {
		background: url(../../../assets/img/service/dataBanner.jpg) center center no-repeat
	}
</style>